module.exports = __webpack_public_path__ + "img/icon-desktop@350h.8979f819.png";